export default [
  {
    code: 10211042010,
    size: "180x80x225",
    paper: "ecobagProperties.color.white",
    color: "ecobagProperties.color.lightblue",
    handle: "ecobagProperties.handles.twisted",
    gsm: 90,
    boxSize: 250,
  },
  {
    code: 10211042011,
    size: "180x80x225",
    paper: "ecobagProperties.color.white",
    color: "ecobagProperties.color.mint",
    handle: "ecobagProperties.handles.twisted",
    gsm: 90,
    boxSize: 250,
  },
  {
    code: 10211042012,
    size: "180x80x225",
    paper: "ecobagProperties.color.white",
    color: "ecobagProperties.color.rose",
    handle: "ecobagProperties.handles.twisted",
    gsm: 90,
    boxSize: 250,
  },
  {
    code: 10232030009,
    size: "180x80x225",
    paper: "ecobagProperties.color.brown",
    color: "ecobagProperties.color.yellow",
    handle: "ecobagProperties.handles.twisted",
    gsm: 90,
    boxSize: 250,
  },
  {
    code: 10232030007,
    size: "180x80x225",
    paper: "ecobagProperties.color.brown",
    color: "ecobagProperties.color.green",
    handle: "ecobagProperties.handles.twisted",
    gsm: 90,
    boxSize: 250,
  },
  {
    code: 10232030005,
    size: "180x80x225",
    paper: "ecobagProperties.color.brown",
    color: "ecobagProperties.color.blue",
    handle: "ecobagProperties.handles.twisted",
    gsm: 90,
    boxSize: 250,
  },
  {
    code: 10232030004,
    size: "180x80x225",
    paper: "ecobagProperties.color.brown",
    color: "ecobagProperties.color.red",
    handle: "ecobagProperties.handles.twisted",
    gsm: 90,
    boxSize: 250,
  },
  {
    code: 10232030003,
    size: "180x80x225",
    paper: "ecobagProperties.color.brown",
    color: "ecobagProperties.color.black",
    handle: "ecobagProperties.handles.twisted",
    gsm: 90,
    boxSize: 250,
  },
  {
    code: 10432030009,
    size: "240x100x320",
    paper: "ecobagProperties.color.brown",
    color: "ecobagProperties.color.yellow",
    handle: "ecobagProperties.handles.twisted",
    gsm: 90,
    boxSize: 250,
  },
  {
    code: 10432030007,
    size: "240x100x320",
    paper: "ecobagProperties.color.brown",
    color: "ecobagProperties.color.green",
    handle: "ecobagProperties.handles.twisted",
    gsm: 90,
    boxSize: 250,
  },
  {
    code: 10432030005,
    size: "240x100x320",
    paper: "ecobagProperties.color.brown",
    color: "ecobagProperties.color.blue",
    handle: "ecobagProperties.handles.twisted",
    gsm: 90,
    boxSize: 250,
  },
  {
    code: 10432030004,
    size: "240x100x320",
    paper: "ecobagProperties.color.brown",
    color: "ecobagProperties.color.red",
    handle: "ecobagProperties.handles.twisted",
    gsm: 90,
    boxSize: 250,
  },
  {
    code: 10432030003,
    size: "240x100x320",
    paper: "ecobagProperties.color.brown",
    color: "ecobagProperties.color.black",
    handle: "ecobagProperties.handles.twisted",
    gsm: 90,
    boxSize: 250,
  },
]
